import { Link } from "react-router-dom";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { Image } from "../../services/shirts/types";
import DialogService from "../Dialog/dialogService";
import ImagesUploaderForm from "../ImagesUploaderForm/ImagesUploaderForm";
import ImagePreview from "../ImagePreview/ImagePreview";
import ImageButton from "../../img/icons/addImage.png";

interface ImageUploaderProps {
  addImage: Function;
  removeImage: Function;
  images: Array<Image>;
  error?: boolean;
}

/**
 * Component used to select and preview images before upload it.
 */
export const ImageUploader = ({
  addImage,
  removeImage,
  images,
  error,
}: ImageUploaderProps) => {
  const { openXS } = DialogService();

  const isMobile = useMediaQuery("(max-width:600px)");
  const previewSize = isMobile ? 100 : 200;

  const boxStyle = {
    marginTop: "25px",
    backgroundColor: "#e3e8ff",
    borderRadius: "5px",
    borderStyle: "dashed",
    borderColor: "#4663ff",
    borderWidth: "3px",
    paddingTop: "10px",
    paddingBottom: "10px",
  };

  const openModal = () => {
    openXS("New Photo", <ImagesUploaderForm addImage={addImage} />, []);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          marginBottom: "1rem",
          ...boxStyle,
        }}
      >
        <Box sx={{ width: 50 }}>
          <img className="bannerImge" src={ImageButton} alt="banner image" />
        </Box>
        <Box>
          <Link onClick={openModal} to="">
            <a className="default-btn move-right">
              <span>Upload Photo</span>
            </a>
          </Link>
        </Box>
        <Box>
          <Typography variant="h6" sx={{ color: "#6f7d95" }}>
            Max 2 MB
          </Typography>
        </Box>
      </Box>

      {error === true && (
        <Box>
          <Typography variant="h6" sx={{ color: "red" }}>
            * Mandatory field
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
        }}
      >
        {images.map((img, index) => (
          <Box key={index} sx={{ padding: "5px" }}>
            <ImagePreview
              image={img}
              index={index}
              removeImage={removeImage}
              width={previewSize}
              height={previewSize}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ImageUploader;
